export default {"src":"/_next/static/media/gamingLogo3.4c5119cd.svg","height":72,"width":80,"blurWidth":0,"blurHeight":0};